import { render, staticRenderFns } from "./TorresPanorama.vue?vue&type=template&id=22d3a5aa"
import script from "./TorresPanorama.vue?vue&type=script&lang=js"
export * from "./TorresPanorama.vue?vue&type=script&lang=js"
import style0 from "./TorresPanorama.vue?vue&type=style&index=0&id=22d3a5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports